import { BrowserRouter as Router, Outlet } from 'react-router'
import { AppRoutes } from './utils/routes'
import './i18n/config'
import './services/async-jobs/task-type-registrations'
import { pdfjs } from 'react-pdf'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ToastProvider } from './components/toast'

import 'react-pdf/dist/Page/TextLayer.css'
import 'react-pdf/dist/Page/AnnotationLayer.css'

export const AppRoot = () => {
  pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
  ).toString()
  return (
    <Router>
      <ToastProvider>
        <AppRoutes />
        <Outlet />
        <ToastContainer position="top-right" autoClose={3000} />
      </ToastProvider>
    </Router>
  )
}

export const App = () => {
  return <AppRoot />
}
